import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import PostListItem from '../post-list-item';
import CommentListItem from '../comment-search-list-item';
import Pagination from '../pagination-regular';
import { HorizontalSeparator } from '../../components/separator';
import withCardBorderWidth from '../../hoc/with-card-border-width';
import styles from './search-results-list.scss';
import { bindActionCreators } from 'redux';
import { changePage } from '../../actions/change-page';
import { connect } from 'react-redux';

const POST = 'post';
const COMMENT = 'comment';
const ITEMS_PER_PAGE = 20;

class SearchResultsDesktopList extends Component {
  state = {
    page: 1,
    from: 0,
    to: ITEMS_PER_PAGE,
  };

  constructor(props) {
    super(props);

    this.handlePageChange = this.handlePageChange.bind(this);
  }

  handlePageChange({ page, from, to }) {
    this.setState({ page, from, to });
  }

  renderItem(post, query, onPostLikeClick, onCommentLikeClick) {
    const separator = (
      <div className={styles.separator}>
        <HorizontalSeparator key={`${post._id}-separator`}/>
      </div>
    );
    switch (post.type) {
      case POST:
        return [
          <PostListItem
            key={post._id}
            type={PostListItem.SEARCH}
            post={post}
            query={query}
            onLikeClick={onPostLikeClick}
          />,
          separator,
        ];
      case COMMENT:
        return [
          <CommentListItem
            key={post._id}
            type={PostListItem.SEARCH}
            comment={post}
            query={query}
            onLikeClick={onCommentLikeClick}
          />,
          separator,
        ];
      default:
        return null;
    }
  }

  render() {
    const { posts, query, onPostLikeClick, onCommentLikeClick, borderWidth } = this.props;
    const { page, from, to } = this.state;
    const style = {
      borderWidth,
      marginTop: -borderWidth,
    };
    return (
      <div className={classNames(styles.container, 'search-results-list')}>
        <div className={classNames(styles.wrapper, 'forum-card-border-color')} style={style}>
          {posts.slice(from, to).map(post => this.renderItem(post, query, onPostLikeClick, onCommentLikeClick))}
          <Pagination
            className={classNames(styles.pagination, 'forum-card-background-color')}
            page={page}
            entityCount={posts.length}
            showPerPage={ITEMS_PER_PAGE}
            onChange={this.handlePageChange}
          />
        </div>
      </div>
    );
  }
}

SearchResultsDesktopList.propTypes = {
  posts: PropTypes.array.isRequired,
  borderWidth: PropTypes.number.isRequired,
  query: PropTypes.string,
  onPostLikeClick: PropTypes.func,
  onCommentLikeClick: PropTypes.func,
  changePage: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      changePage,
    },
    dispatch
  );

export default connect(undefined, mapDispatchToProps)(withCardBorderWidth(SearchResultsDesktopList));



// WEBPACK FOOTER //
// ./app/components/search-results-list/search-results-desktop-list.js